<div class="container mt-2">
  <div class="row">
    <!-- Título de la página -->
    <div class="col-md-12">
      <app-title-with-back>Consulta de Usuarios App</app-title-with-back>
    </div>

    <!-- Filtros y acciones -->
    <div class="col-md-12">
      <div class="row mb-3">
        <!-- Acciones de la tabla -->
        <div class="col-md-4"></div>

        <!-- Título "Usuarios Existentes" -->
        <div class="col-md-4 my-3 my-md-0">
          <h2 uni-heading alignText="center" class="mt-1">Usuarios Existentes</h2>
        </div>

        <!-- Botón para agregar un nuevo usuario -->
        <div class="col-md-4">
          <div class="actions"></div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <filtroapp-tabla (searchClicked)="filterUsuarios($event)" [showForm]="showForm"></filtroapp-tabla>
    </div>

    <!-- Tabla de datos -->
    <div class="col-md-12" *ngIf="hasSearched">
      <uni-table [columns]="columns" [data]="tableUsuarioApp$ | async" [excelName]="excelName"> </uni-table>
    </div>
  </div>
</div>
